import { CustomCellRendererProps } from 'ag-grid-react'

import { useTradeTypesQuery } from '@/react-query/queries/static'

export interface TradeTypeCellRendererProps extends CustomCellRendererProps {}

export const TradeTypeCellRenderer: React.FC<TradeTypeCellRendererProps> = ({ node, value }) => {
  const query = useTradeTypesQuery()

  const label = query.data?.find((c) => c.value == value)?.label ?? value

  if (node.group) {
    return null
  }

  return <>{label}</>
}
